import {
  CREATE_TARGET,
  DELETE_TARGET,
  UPDATE_TARGET,
  FETCH_MARKET_TARGETS,
  TARGETS_LOADING,
} from '../actions/targetDeployments';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_MARKET_TARGETS:
      return {
        ...state,
        targetDeployments: action.payload,
      };
    case TARGETS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CREATE_TARGET:
    case DELETE_TARGET:
    case UPDATE_TARGET:
    default:
      return state;
  }
}
